import NewsPreview from './NewsPreview';

export default NewsPreview;
